














import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class InputFile extends Vue {
	@Prop({ type: String, required: true })
	name!: string;

	@Prop({
	    type: String,
	    required: false,
	    default: 'Please select your file(s)'
	})
	placeholder!: string;

	@Prop({ type: String, required: false })
	fileTypes!: string;

	public $refs!: {
		file: HTMLInputElement;
	};

	public fileCount: number = 0;
	public fileSize: string = '';

	formatBytes(bytes: number, decimals = 2) {
	    if (bytes === 0) return '0 Bytes';

	    const k = 1024;
	    const dm = decimals < 0 ? 0 : decimals;
	    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	    const i = Math.floor(Math.log(bytes) / Math.log(k));

	    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	get id() {
	    return this.name + new Date().valueOf();
	}

	changedInput(event: any) {
	    const files = event.target.files;
	    this.fileCount = files.length;
	    let fileSize = 0;
	    for (const file of files) {
	        fileSize += file.size;
	    }
	    this.fileSize = this.formatBytes(fileSize);

	    const acceptedExtensions = this.fileTypes;
	    const acceptedFiles: any[] = [];
	    for (const file of files) {
	        const extension = file.name.split('.').pop() as string;
	        if (!extension || extension.length === 0 || !acceptedExtensions.includes(extension.toLowerCase())) {
	            continue;
	        }

	        acceptedFiles.push(file);
	    }

	    if (acceptedFiles.length === 0) return;

	    const filenames = acceptedFiles.map(x => x.name);
		this.$refs.file.parentElement!.setAttribute('data-text', filenames.join(', '));

		this.$emit('change', acceptedFiles, () => {
		    // this.files = [];
		});
	}

	clearInput(e: any) {
	    this.$refs.file.value = '';
	}
}
